import { useEffect, useState } from 'react';

import { NATIVE_POST_MESSAGE_TYPE, isWebView, sendPostMessageToNative } from '@/utils/mobile/RNPlugins';

interface EventListenerObject extends Event {
  data: string;
}

/**
 * Back Event Handler Hook
 * @returns isBackEventTrigger: boolean,
 * @returns onPreventBackEvent: (isPrevent: boolean) => void;
 */

const useBackEventHandler = () => {
  const [isBackEventTrigger, setIsBackEventTrigger] = useState<boolean>(false);

  /**
   * 뒤로가기 막고 해제 할 경우 앱으로 이벤트 전송
   * 뒤로가기 이벤트 막을경우 true, 해제할 경우 false
   */
  const onPreventBackEvent = (isPrevent: boolean) => {
    if (isWebView()) {
      sendPostMessageToNative(NATIVE_POST_MESSAGE_TYPE.SET_PREVENT_BACK_EVENT, {
        isPreventBackEvent: isPrevent,
      });
    }
  };

  /**
   * 뒤로가기 이벤트 발생할 경우 앱에서 이벤트 받음
   * 뒤로가기 이벤트 발생 true
   * onPreventBackEvent(false) 호출시 false
   */
  useEffect(() => {
    const handleEvent = (event: EventListenerObject) => {
      if (Object.keys(JSON.parse(event.data))) {
        const { isBackEventTrigger = false } = JSON.parse(event.data);
        setIsBackEventTrigger(isBackEventTrigger);
      }
    };
    document.addEventListener('message', handleEvent as EventListener);

    return () => {
      document.removeEventListener('message', handleEvent as EventListener);
    };
  }, []);
  return { isBackEventTrigger, onPreventBackEvent };
};

export default useBackEventHandler;
